import { OrderExtraDetails, VendorDetails } from "@client/stores";

const getOrderExtras: (vendorDetails?: VendorDetails) => OrderExtraDetails = (
	vendorDetails
) => ({
	platform: (process.env.IS_SERVER
		? "server"
		: "webapp") as OrderExtraDetails["platform"],
	store_opening_hours: vendorDetails?.time.time_acceptance_hours || "N/A",
});

export default getOrderExtras;
